import { createContext } from "react";

/*
 * Contexto del componente wizard.
 */
const WizardContext = createContext({
  step: 0,
  extraInfo: {},
  localSlot: {},
  appointmentData: {},
  persistentData: {},
  setStep: () => {},
  setExtraInfo: () => {},
  setLocalSlot: () => {},
  setAppointmentData: () => {},
  setPersistentData: () => {},
});

export default WizardContext;
